<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";

    export let url;
    export let targetName = 'ひとつ上';


    onMount(() => {
    });


</script>

<div class="back-link-view">
    <a href={url}>
        <FontAwesomeView icon="chevron-left"/>
        { targetName }に戻る

    </a>


</div>
<style lang="scss">
    .back-link-view {
        font-size: 0.5em;
        padding-bottom: 0.5em;


        > a {
            display: inline-block;
            transition-duration: 0.5s;

            &:hover {
                transform: translateX(-1em);
            }

        }

    }
</style>